<h2 mat-dialog-title style="color: #A20000; text-align: center;">WARNING</h2>
<mat-dialog-content>
  <div style="color: #A20000;">The following open e-Forms were created from this template and will NOT be updated if the changes made are saved.</div>
  <div style="padding-top:10px;padding-bottom:10px;">If these changes need to be made to any of these e-Forms, they will need to be made individually to each one.</div>
  <div *ngFor="let instance of instances" style="padding-left:40px;">{{template.Name}} - {{instance.Name}}</div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <tyl-button image="next arrow.png" label="Continue" (clickEvent)="continueClick()"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>
